module.exports = __webpack_public_path__ + "static/media/s2.f6532a91.jpg";